module.exports = __webpack_public_path__ + "img/ivTest_sub48.a3785424.jpg";